import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Get an overview of the workflow configuration and navigate its parts
 * @primary FSM dashboard
 * @persona danilo-tech
 */
export const Route = createFileRoute("/app/admin/fsm-workflows/")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
